import React from 'react'
import { Row, Col, } from 'reactstrap'
import { SetItemsFilterGenerator, SetItemsFilterRow, } from '../ManageSetsComponents'

/*
  <SetItemsFilterBar
    filters={props.filters}
    setItemFilter={props.setItemFilter}
    removeItemFilter={props.removeItemFilter}
    filterBySelected={props.filterBySelected}
    filterText={props.filterText}
    handleFilterTextChange={props.handleFilterTextChange}
    handleFilterBySelectedChange={props.handleFilterBySelectedChange}
    resetFilterGenerator={props.resetFilterGenerator}
  />
*/

export default function SetItemsFilterBar(props) {
  return (
    <div>
      <Row>
        <Col>
          <SetItemsFilterRow
            filters={props.filters}
            removeItemFilter={props.removeItemFilter}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <SetItemsFilterGenerator 
            filters={props.filters}
            setItemFilter={props.setItemFilter}
            filterBySelected={props.filterBySelected}
            filterText={props.filterText}
            handleFilterTextChange={props.handleFilterTextChange}
            handleFilterBySelectedChange={props.handleFilterBySelectedChange}
            resetFilterGenerator={props.resetFilterGenerator}
          />
        </Col>
      </Row>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Content/ManageSetsComponents/SetItemsFilterBar.js